import React, { useState, useEffect } from "react";
import { Button, IconButton, Input, Snackbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { BsPencil } from "react-icons/bs";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import AvatarPicture from "../components/AvatarPicture";
import CropImage from "../components/CropImage";
import "../assets/css/profile.css";
import { setUser } from "../redux/actions/AuthAction";
import { setToast } from "../redux/actions/ToastAction";
import Alert from "../components/alert";
import config from "../api/config";

const Profile = () => {
  const [user_name, setUser_name] = useState("");
  const navigate = useHistory();
  // reducer
  const reducer_user = useSelector((state) => state.reducer.user, shallowEqual);
  const reducer_toast = useSelector(
    (state) => state.reducer.toast,
    shallowEqual
  );
  const dispatch = useDispatch();
  // image
  const [imgModal, setImgModal] = useState(false);
  // fields
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phnumber, setPhnumber] = useState("");

  const [npassword, setNpassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [avatar, setAvatar] = useState(null);
  const [imgData, setImgData] = useState(null);
  const [uploadingAvatar, setUploadingAvatar] = useState(false);

  useEffect(() => () => {
    if (imgData) URL.revokeObjectURL(imgData);
  }, [imgData]);

  useEffect(() => {

    if (reducer_user) {
      setUser_name(`${reducer_user.firstName} ${reducer_user.lastName}`);
      setSurname(reducer_user.lastName);
      setName(reducer_user.firstName);

      setPhnumber(reducer_user.phoneNumber);

      setAvatar(reducer_user.photo?.link || null);

    }
  }, [reducer_user]);
  const reloadHandler = () => {
    return config
      .get("/api/auth/v1/me")
      .then((data) => dispatch(setUser(data.data.objectKoinot)));
  };

  // imageupload
  const imageHandler = (file) => {
    if (file) {
      setImgData(URL.createObjectURL(file));
      setImgModal(true);
    }
  };
  // image cut
  const imageSubmitHandler = async (croppedImage) => {
    const formData = new FormData();
    formData.append("file", croppedImage, "avatar.jpg");
    setUploadingAvatar(true);
    try {
      const response = await config.post("/koinot/attachment/v1/userProfile", formData);
      const savedImage = response.data?.objectKoinot?.[0];
      if (!savedImage?.fileId || !savedImage?.link) {
        throw new Error("The upload did not return a saved image");
      }
      await reloadHandler();
      setAvatar(savedImage.link);
      dispatch(setToast(true, "success", "Фото сохранено"));
    } finally {
      setUploadingAvatar(false);
    }
  };

  // submit
  const handleSubmit = async () => {
    const sub = {
      firstName: name,
      lastName: surname,
      phoneNumber: phnumber,
      username: reducer_user?.username,
      language: reducer_user?.language,
      address: reducer_user?.address,
      dateOfBirth: reducer_user?.dateOfBirth,
      longitude: reducer_user?.longitude || 0,
      latitude: reducer_user?.latitude || 0,
    };

    try {
      await config.post("/api/auth/v1/editMe", sub);
      dispatch(setToast(true, "success", "Успешно Изменено"));
      // setImageView(true);
    } catch (err) {
      dispatch(
        setToast(
          true,
          "error",
          "Ошибка при редактировании, Убедитесь, что все поля заполнены правильно."
        )
      );
    }
  };
  const handleSubmitPassword = async () => {
    try {
      await config.post("/api/auth/v1/newPassword", { password: npassword });
      dispatch(setToast(true, "success", "Успешно Изменено"));
      // setImageView(true);
    } catch (err) {
      dispatch(
        setToast(
          true,
          "error",
          "Ошибка при редактировании, Убедитесь, что все поля заполнены правильно."
        )
      );
    }
  };
  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  return (
    <div className="">
      <Snackbar
        open={reducer_toast.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer_toast.severity}
          sx={{ width: "100%" }}
        >
          {reducer_toast.content}
        </Alert>
      </Snackbar>
      {/* image --------------------- */}
      <CropImage
        _callback={imageSubmitHandler}
        img={imgData}
        avatar={true}
        modal={imgModal}
        setModal={(open) => {
          setImgModal(open);
          if (!open) setImgData(null);
        }}
      />
      {/* image ---------------------- */}
      <div className="d-flex">
        <Button
          onClick={() => navigate.push(`/`)}
          variant="outlined"
          startIcon={<IoIosArrowBack />}
          style={{
            padding: "12px 22px",
            borderRadius: "40px",
            fontWeight: "bold",
          }}
        >
          Отменить и назад
        </Button>
        <h3 className="ms-5">Изменить профиль</h3>
      </div>
      <div className="p-4">
        <div className="row">
          <div className="col-6 my-3 d-flex justify-content-around align-items-center">
            <div className="avatar">
              <AvatarPicture size="100" image={avatar} />
              <div className="avatar_button">
                <label htmlFor="icon-button-file" className="m-0">
                  <Input
                    accept="image/*"
                    id="icon-button-file"
                    style={{ display: "none" }}
                    type="file"
                    disabled={uploadingAvatar}
                    onChange={(e) => {
                      imageHandler(e.target.files[0]);
                      e.target.value = "";
                    }}
                  />
                  <IconButton
                    size="small"
                    color="primary"
                    variant="contained"
                    component="span"
                    aria-label="Изменить фото профиля"
                    disabled={uploadingAvatar}
                    style={{
                      background: "var(--second-color)",
                      color: "var(--txt-color)",
                    }}
                  >
                    <BsPencil />
                  </IconButton>
                </label>
              </div>
            </div>
            <h2 className="">{user_name}</h2>
          </div>
        </div>

        <div className="row">
          <div className="col-8">
            <div className="row">
              <div className="col-6">
                <label htmlFor="name">Имя</label> <br />
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  id="name"
                  type="text"
                  placeholder="Введите Имя"
                />
              </div>
              <div className="col-6">
                <label htmlFor="surname">Фамилия</label> <br />
                <input
                  value={surname}
                  onChange={(e) => setSurname(e.target.value)}
                  id="surname"
                  type="text"
                  placeholder="Введите Фамилия"
                />
              </div>
            </div>
            <div className="row">
              {/* <div className="col-6">
                <label htmlFor="email">Эл. адрес</label> <br />
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="email"
                  type="text"
                  placeholder="Введите свой адрес электронной почты"
                />
              </div> */}
              <div className="col-6">
                <label htmlFor="phnumber">Телефонный номер</label> <br />
                <input
                  value={phnumber}
                  onChange={(e) => setPhnumber(e.target.value)}
                  id="phnumber"
                  type="text"
                  placeholder="Введите Телефонный номер"
                />
              </div>
            </div>
          </div>
          <div className="col-6 my-5">
            <Button
              onClick={handleSubmit}
              variant="contained"
              style={{
                padding: "12px 22px",
                borderRadius: "40px",
                fontWeight: "bold",
                background: "var(--second-color)",
              }}
            >
              Сохранить
            </Button>{" "}
            <br />
            <div className="row mt-5">
              <div className="col-6">
                <label htmlFor="npassword">Новый пароль</label> <br />
                <input
                  value={npassword}
                  onChange={(e) => setNpassword(e.target.value)}
                  id="npassword"
                  type="password"
                  placeholder=""
                />
              </div>
              <div className="col-6">
                <label htmlFor="repassword">Повторите пароль</label> <br />
                <input
                  value={repassword}
                  onChange={(e) => setRepassword(e.target.value)}
                  id="repassword"
                  type="password"
                  placeholder=""
                />
              </div>

              <div
                className={`${
                  npassword !== repassword ? "opacity-25" : ""
                } mt-5 position-relative`}
              >
                {npassword !== repassword ? <div className="hide"></div> : null}
                <Button
                  onClick={handleSubmitPassword}
                  variant="contained"
                  style={{
                    padding: "12px 22px",
                    borderRadius: "40px",
                    fontWeight: "bold",
                    background: "var(--second-color)",
                  }}
                >
                  Сохранить пароль
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
